// src/i18n/index.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 📦 Import translations
import en from './translations/en.json';
import es from './translations/es.json';
import fr from './translations/fr.json';
import id from './translations/id.json';
import pt from './translations/pt.json';
import sw from './translations/sw.json';
import vi from './translations/vi.json';
import zh from './translations/zh.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      id: { translation: id },
      pt: { translation: pt },
      sw: { translation: sw },
      vi: { translation: vi },
      zh: { translation: zh },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'fr', 'id', 'pt', 'sw', 'vi', 'zh'],
    nonExplicitSupportedLngs: true, // accept "pt-BR" as "pt"
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'querystring'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
